// Load profile analysis
// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodePowerLoadProfilesAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodePowerLoadProfilesAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/load-profile-analysis',
)({
  component: EnergyTreeNodePowerLoadProfilesAnalysisPage,
  staticData: { crumb: 'energyxplorer:app_bar.energy_analysis_load_profile' },
});
